import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavComponent } from '../shared/top-nav/top-nav.component';

@Component({
  selector: 'app-succession-plan',
  standalone: true,
  imports: [CommonModule, TopNavComponent],
  templateUrl: './succession-plan.component.html',
  styleUrl: './succession-plan.component.scss',
})
export class SuccessionPlanComponent {
  expandedPlanId: number | null = null;

  successionPlans = [
    {
      id: 1,
      title: 'Role X and project',
      status: 'Critical Role',
      experience: 'Yes',
      incumbent: 'Incumbent',
      description: 'Cherry blossom head of region 3',
      details:
        'Pizza ipsum dolor amet lovers buffalo. Sauce personal peppers fresh bacon meatball ham garlic. Beef party party ricotta Aussie hand toi mushrooms onions. Sausage lot banana Bianca ranch pepperoni lasagna.',
      suggestedSuccessors: 'Suggested successor(s)',
      candidates: [
        {
          id: 1,
          name: 'Jonás Sebastiana',
          role: 'Development Action Plan',
          status: 'Ready Now',
          avatar: '👨‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
        {
          id: 2,
          name: 'Inés Santiago',
          role: 'Development Action Plan',
          status: 'Ready Later',
          avatar: '👩‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
        {
          id: 3,
          name: 'Alonso Valentín',
          role: 'Development Action Plan',
          status: 'Emerging successor',
          avatar: '👨‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
        {
          id: 4,
          name: 'Josefa Patricio',
          role: 'Development Action Plan',
          status: 'External Pipeline',
          avatar: '👩‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
      ],
    },
    {
      id: 2,
      title: 'Role X and project',
      status: 'Critical Role',
      experience: 'Yes',
      incumbent: 'Incumbent',
      description: 'Cherry blossom head of region 3',
      details:
        'Pizza ipsum dolor amet lovers buffalo. Sauce personal peppers fresh bacon meatball ham garlic. Beef party party ricotta Aussie hand toi mushrooms onions. Sausage lot banana Bianca ranch pepperoni lasagna.',
      suggestedSuccessors: 'Suggested successor(s)',
      candidates: [
        {
          id: 1,
          name: 'Jonás Sebastiana',
          role: 'Development Action Plan',
          status: 'Ready Now',
          avatar: '👨‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
        {
          id: 2,
          name: 'Inés Santiago',
          role: 'Development Action Plan',
          status: 'Ready Later',
          avatar: '👩‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
      ],
    },
    {
      id: 3,
      title: 'Role X and project',
      status: 'Critical Role',
      experience: 'Yes',
      incumbent: 'Incumbent',
      description: 'Cherry blossom head of region 3',
      details:
        'Pizza ipsum dolor amet lovers buffalo. Sauce personal peppers fresh bacon meatball ham garlic. Beef party party ricotta Aussie hand toi mushrooms onions. Sausage lot banana Bianca ranch pepperoni lasagna.',
      suggestedSuccessors: 'Suggested successor(s)',
      candidates: [
        {
          id: 1,
          name: 'Alonso Valentín',
          role: 'Development Action Plan',
          status: 'Emerging successor',
          avatar: '👨‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
      ],
    },
    {
      id: 4,
      title: 'Role X and project',
      status: 'Critical Role',
      experience: 'Yes',
      incumbent: 'Incumbent',
      description: 'Cherry blossom head of region 3',
      details:
        'Pizza ipsum dolor amet lovers buffalo. Sauce personal peppers fresh bacon meatball ham garlic. Beef party party ricotta Aussie hand toi mushrooms onions. Sausage lot banana Bianca ranch pepperoni lasagna.',
      suggestedSuccessors: 'Suggested successor(s)',
      candidates: [
        {
          id: 1,
          name: 'Josefa Patricio',
          role: 'Development Action Plan',
          status: 'External Pipeline',
          avatar: '👩‍💼',
          description:
            'Pizza ipsum dolor meat lovers buffalo. Aussie steak sauce white Bianca olives platter thin string.',
        },
      ],
    },
    {
      id: 5,
      title: 'Role X and project',
      status: 'Critical Role',
      experience: 'Yes',
      incumbent: 'Incumbent',
      description: 'Cherry blossom head of region 3',
      details:
        'Pizza ipsum dolor amet lovers buffalo. Sauce personal peppers fresh bacon meatball ham garlic. Beef party party ricotta Aussie hand toi mushrooms onions. Sausage lot banana Bianca ranch pepperoni lasagna.',
      suggestedSuccessors: 'Suggested successor(s)',
      candidates: [],
    },
    {
      id: 6,
      title: 'Role X and project',
      status: 'Critical Role',
      experience: 'Yes',
      incumbent: 'Incumbent',
      description: 'Cherry blossom head of region 3',
      details:
        'Pizza ipsum dolor amet lovers buffalo. Sauce personal peppers fresh bacon meatball ham garlic. Beef party party ricotta Aussie hand toi mushrooms onions. Sausage lot banana Bianca ranch pepperoni lasagna.',
      suggestedSuccessors: 'Suggested successor(s)',
      candidates: [],
    },
  ];

  constructor() {}

  toggleExpansion(planId: number, event: Event) {
    event.stopPropagation();
    this.expandedPlanId = this.expandedPlanId === planId ? null : planId;
  }

  isExpanded(planId: number): boolean {
    return this.expandedPlanId === planId;
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'ready now':
        return 'status-ready-now';
      case 'ready later':
        return 'status-ready-later';
      case 'emerging successor':
        return 'status-emerging';
      case 'external pipeline':
        return 'status-external';
      default:
        return 'status-default';
    }
  }
}
